import { __decorate, __metadata } from 'tslib';
import { ɵɵdefineInjectable, Injectable, EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { UiBsTranslateService, UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { AngularSvgIconModule } from 'angular-svg-icon';

let UiCDashboardHeaderService = class UiCDashboardHeaderService {
    constructor() { }
};
UiCDashboardHeaderService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UiCDashboardHeaderService_Factory() { return new UiCDashboardHeaderService(); }, token: UiCDashboardHeaderService, providedIn: "root" });
UiCDashboardHeaderService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __metadata("design:paramtypes", [])
], UiCDashboardHeaderService);

let UiCDashboardHeaderComponent = class UiCDashboardHeaderComponent {
    constructor(translate) {
        this.translate = translate;
        this.showSearchBar = true;
        this.grid = new EventEmitter();
        this.home = new EventEmitter();
        this.FlagActive = new EventEmitter();
        this.FlagActiveNotification = new EventEmitter();
        this.listMenuResult = new EventEmitter();
        this.changeLanguage = new EventEmitter();
        this.items = [];
    }
    ngOnInit() { }
    onFlagActiveNotification() {
        this.FlagActiveNotification.emit();
    }
    onFlagActive() {
        this.FlagActive.emit();
    }
    iconGrid() {
        this.grid.emit();
    }
    goToHome() {
        this.home.emit();
    }
    initializeItems() {
        this.items = this.listMenu;
    }
    changeLanguageEvent() {
        this.changeLanguage.emit(true);
    }
    getItems(ev) {
        this.initializeItems();
        const val = ev.target.value;
        if (val && val.trim() !== '') {
            this.items = this.items.filter((item) => {
                return (this.translate.applyTranslate(item.label)).toLowerCase().indexOf(val.toLowerCase()) > -1;
            });
            this.listMenuResult.emit(this.items);
        }
        else {
            this.listMenuResult.emit();
        }
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCDashboardHeaderComponent.prototype, "userName", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCDashboardHeaderComponent.prototype, "flagGrid", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCDashboardHeaderComponent.prototype, "brand", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCDashboardHeaderComponent.prototype, "nameInitials", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCDashboardHeaderComponent.prototype, "FlagActiveBtn", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCDashboardHeaderComponent.prototype, "userCompleteName", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCDashboardHeaderComponent.prototype, "iconImg", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCDashboardHeaderComponent.prototype, "FlagActiveNotificationBtn", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCDashboardHeaderComponent.prototype, "isMenuApplication", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCDashboardHeaderComponent.prototype, "listMenu", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCDashboardHeaderComponent.prototype, "inputSearchbar", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCDashboardHeaderComponent.prototype, "pathFlag", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCDashboardHeaderComponent.prototype, "showSearchBar", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDashboardHeaderComponent.prototype, "search", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDashboardHeaderComponent.prototype, "grid", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDashboardHeaderComponent.prototype, "home", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDashboardHeaderComponent.prototype, "FlagActive", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDashboardHeaderComponent.prototype, "FlagActiveNotification", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDashboardHeaderComponent.prototype, "listMenuResult", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDashboardHeaderComponent.prototype, "changeLanguage", void 0);
UiCDashboardHeaderComponent = __decorate([
    Component({
        selector: 'ui-c-dashboard-header',
        template: "<div class=\"dashboard-header\">\n  <ion-header>\n    <ion-toolbar class=\"container\">\n      <ion-row class=\"row-principal\">\n        <ion-col [size]=\"8\" [sizeLg]=\"8\" class=\"ion-padding-horizontal\">\n          <ion-row class=\"search-row\">\n            <ion-col [size]=\"5\" [sizeLg]=\"4\" class=\"ion-no-padding\" (click)=\"goToHome()\">\n              <ion-img class=\"ion-img\" [src]=\"brand\"> </ion-img>\n            </ion-col>\n            <ion-col [size]=\"7\" [sizeLg]=\"8\" class=\"ion-no-padding\" *ngIf=\"showSearchBar\">\n              <ion-searchbar type=\"text\" debounce=\"500\"\n                placeholder=\"{{'DASHBOARD.SEARCH_BAR.PLACEHOLDER' | wlpTranslate}}\" [value]=\"inputSearchbar\"\n                (ionChange)=\"getItems($event)\"></ion-searchbar>\n            </ion-col>\n          </ion-row>\n        </ion-col>\n        <ion-col [size]=\"4\" [sizeLg]=\"4\" class=\"ion-padding-horizontal icon-col\">\n          <ion-row class=\"ion-justify-content-end ion-align-items-center\">\n            <!-- <ion-col size=\"2\" class=\"ion-no-padding text-center\" *ngIf=\"false\">\n              <ion-button (click)=\"onFlagActiveNotification()\"\n                [ngClass]=\"FlagActiveNotificationBtn ? 'user-btn' : 'user-btn-off'\" class=\"btn-notification\">\n                <ion-icon class=\"font-size-27\" name=\"notifications-outline\"></ion-icon>\n              </ion-button>\n            </ion-col> -->\n            <ion-col [size]=\"2\" [sizeLg]=\"2\" class=\"user-col ion-no-padding text-center\">\n              <ion-button (click)=\"onFlagActive()\" [ngClass]=\"FlagActiveBtn ? 'user-btn' : 'user-btn-off'\">\n                <p id=\"username-icon\" class=\"text-center font-weight-bold\">{{ nameInitials }}</p>\n                <p class=\"user-name\">{{ userName }}</p>\n              </ion-button>\n            </ion-col>\n            <ion-col *ngIf=\"showSearchBar\" [sizeLg]=\"2\" class=\"ion-no-padding\">\n              <ion-toolbar class=\"language-toolbar\">\n                <ion-buttons slot=\"end\">\n                  <ion-button (click)=\"changeLanguageEvent()\">\n                    <svg-icon [src]=\"pathFlag\"></svg-icon>\n                  </ion-button>\n                </ion-buttons>\n              </ion-toolbar>\n            </ion-col>\n            <ion-col size=\"2\" class=\"ion-no-padding\" *ngIf=\"isMenuApplication\">\n              <ion-button (click)=\"iconGrid()\" [ngClass]=\"flagGrid ? 'user-btn' : 'user-btn-off'\"\n                class=\"btn-notification\">\n                <ion-icon class=\"font-size-35\" [src]=\"iconImg\"></ion-icon>\n              </ion-button>\n            </ion-col>\n          </ion-row>\n        </ion-col>\n      </ion-row>\n    </ion-toolbar>\n  </ion-header>\n</div>",
        styles: [""]
    }),
    __metadata("design:paramtypes", [UiBsTranslateService])
], UiCDashboardHeaderComponent);

let UiCDashboardHeaderModule = class UiCDashboardHeaderModule {
};
UiCDashboardHeaderModule = __decorate([
    NgModule({
        declarations: [UiCDashboardHeaderComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            IonicModule,
            RouterModule,
            UiBsTranslateModule,
            AngularSvgIconModule.forRoot()
        ],
        exports: [
            UiCDashboardHeaderComponent
        ]
    })
], UiCDashboardHeaderModule);

export { UiCDashboardHeaderComponent, UiCDashboardHeaderModule, UiCDashboardHeaderService };
//# sourceMappingURL=wlp-ui-c-dashboard-header.js.map
